import { SelectField } from '@mews-commander/form';
import { WithBookablePeriod } from '@mews-commander/types';
import { createOption } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { CancellationFeeExtentFieldOption, CancellationPolicyFormField } from '../../types';
import { LocalizedBookablePeriodWithProducts, LocalizedCancellationPolicyBookablePeriod } from '../../../../components';

const createFeeExtentFieldOptions = ({ bookablePeriod }: WithBookablePeriod) => [
    createOption({
        value: CancellationFeeExtentFieldOption.TimeUnits,
        label: <LocalizedCancellationPolicyBookablePeriod bookablePeriod={bookablePeriod} />,
    }),
    createOption({
        value: CancellationFeeExtentFieldOption.Products,
        label: lt('CancellationFeeExtentProducts'),
    }),
    createOption({
        value: CancellationFeeExtentFieldOption.TimeUnitsAndProducts,
        label: <LocalizedBookablePeriodWithProducts bookablePeriod={bookablePeriod} />,
    }),
];

interface Props extends WithBookablePeriod {
    disabled?: boolean;
}

export const FeeExtentField = ({ bookablePeriod, disabled = false }: Props) => (
    <SelectField
        name={CancellationPolicyFormField.FeeExtent}
        required
        label={lt('FeeExtent')}
        options={createFeeExtentFieldOptions({ bookablePeriod })}
        disabled={disabled}
    />
);
